export default {"src":"/_next/static/media/Reddit.813c4228.svg","height":33,"width":32,"blurWidth":0,"blurHeight":0};